<template>
    <div class="modal-header">
        <a href="javascript:void(0);" style=" display:grid; place-items:center; width: 65px;" @click="close()">
            <img :src="require('@/assets/img/back_btn_new.png')" style="width:15px;">
        </a>
        <div style="flex:1; font-weight:500; font-size:20px; display:grid; place-items:center;">{{title}}</div>
        <div style="width:65px;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MyFeedHeader",
        props: ['title', 'isShowCompleteBtn', 'completeAction'],
        methods : {
            close(){
                this.$GlobalStore.closeLastModal();
            },
        }
    }
</script>

<style scoped>
    .modal-header{display:flex; height:60px; margin-bottom: 20px;}

</style>